export default __webpack_public_path__ + "static/media/exam_overview_tablet.cbd53b8a.jpg";